export const languageCode = 'zh-CN';
export const languageLabel = 'Chinese (Simplified)';

export const translations = {
  AUDIO_DESCRIPTION_OFF: '关闭',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: '隐藏字幕菜单',
  CAPTIONS_OFF: '关闭',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: '搜索视频',
  CAPTIONS_SHOW_MENU: '显示字幕菜单',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: '关闭章节',
  CHAPTERS_OPEN_CHAPTERS: '打开章节',

  CLICK_FOR_SOUND_DESKTOP_TEXT: '点击播放声音',
  CLICK_FOR_SOUND_MOBILE_TEXT: '点按播放声音',

  CONTEXT_MENU_ABOUT_WISTIA: '关于Wistia',
  CONTEXT_MENU_COPIED: '已复制！',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: '复制链接和缩略图',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: '已登录Wistia',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: '在Wistia里打开视频',
  CONTEXT_MENU_REPORT_A_PROBLEM: '报告问题',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: '在Wistia里查看统计信息',

  CUSTOMER_LOGO_LOGO: '标志',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: '退出全屏',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: '全屏',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: '视频',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: '播放',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: '暂停',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: '请添加详细信息',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: '选一个',
  REPORT_A_PROBLEM_DESCRIPTION:
    '感谢您报告问题。我们将附上关于此次会话的技术数据，以帮助我们找出问题所在。哪一项最能描述这个问题？',
  REPORT_A_PROBLEM_DISMISS: '取消',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: '视频无法播放',
  REPORT_A_PROBLEM_OTHER: '其他',
  REPORT_A_PROBLEM_OTHER_CONTEXT: '其他细节或背景信息？',
  REPORT_A_PROBLEM_POOR_QUALITY: '视频质量差',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: '问题类别',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: '问题描述',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: '请选择一个类别',
  REPORT_A_PROBLEM_SEND: '发送',
  REPORT_A_PROBLEM_SENDING: '发送中...',
  REPORT_A_PROBLEM_STUTTER: '视频能播放，但经常卡顿',

  REWATCH: '重看',

  SETTINGS_PLAYBACK_RATE_TITLE: '速度',
  SETTINGS_QUALITY_AUTO: '自动',
  SETTINGS_QUALITY_TITLE: '质量',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: '关闭共享菜单',
  SHARE_CONTROL_OPEN: '打开共享菜单',
  SHARE_COPIED: '已复制！',
  SHARE_DOWNLOAD: '下载',
  SHARE_EMAIL: 'Email',
  SHARE_EMBED: '内嵌',
  SHARE_FACEBOOK: 'Facebook',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',
  SKIP: '跳过',

  STATUS_BAR_EMBED_CODE_COPIED: '嵌入代码已复制到您的剪贴板！',

  THUMBNAIL_VIDEO_THUMBNAIL: '视频缩略图',

  TURNSTILE_DEFAULT_END: '感谢观看！ \n请输入您的邮件地址。',
  TURNSTILE_DEFAULT_START: '请输入您的邮件地址以查看此视频。',
  TURNSTILE_EMAIL_PLACEHOLDER: '您的邮件',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: '名字',
  TURNSTILE_LAST_NAME_PLACEHOLDER: '姓氏',
  TURNSTILE_PLAY: '播放',
  TURNSTILE_SUBMIT: '提交',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: '音量调节',
  VOLUME_TITLE_WHEN_MUTED: '取消静音',
  VOLUME_TITLE_WHEN_UNMUTED: '静音',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'The next video plays in...',
};
